var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_c('div',{staticClass:"success",on:{"click":function($event){return _vm.success()}}},[_c('img',{attrs:{"src":require("../../public/img/成功.png"),"alt":""}}),_c('div',{staticClass:"zhifu"},[_vm._v("支付成功！")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }